import { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";
import api from "../../lib/api";
import { toast } from "sonner";
import { Plus, Trash2 } from "lucide-react";
import ImageUpload from "../../components/ImageUpload";

const empty = { title: "", image: "", link: "", position: "hero", active: true };

export default function BannersAdmin() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState(empty);
  const load = () => api.get("/banners", { params: { active: undefined } }).then(r => setItems(r.data || []));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try { await api.post("/banners", form); toast.success("Banner cadastrado!"); setForm(empty); load(); }
    catch (e) { toast.error("Erro"); }
  };
  const remove = async (id) => { if (!window.confirm("Excluir?")) return; await api.delete(`/banners/${id}`); load(); };

  return (
    <AdminLayout>
      <div data-testid="admin-banners">
        <h1 className="font-serif-display text-4xl font-bold">Banners</h1>
        <div className="grid md:grid-cols-3 gap-6 mt-6">
          <form onSubmit={submit} className="border border-zinc-300 bg-white p-4 space-y-3">
            <h2 className="overline">Novo banner</h2>
            <input type="text" placeholder="Título" required value={form.title} onChange={e => setForm({...form, title: e.target.value})} className="w-full border border-zinc-300 px-3 py-2 font-sans-ui text-sm" data-testid="banner-title" />
            <div>
              <label className="overline">Imagem do Banner</label>
              <ImageUpload value={form.image} onChange={(v) => setForm({...form, image: v})} label="Banner" testid="banner-image-upload" />
            </div>
            <input type="url" placeholder="Link de destino" value={form.link} onChange={e => setForm({...form, link: e.target.value})} className="w-full border border-zinc-300 px-3 py-2 font-sans-ui text-sm" />
            <select value={form.position} onChange={e => setForm({...form, position: e.target.value})} className="w-full border border-zinc-300 px-3 py-2 font-sans-ui text-sm">
              <option value="hero">Hero (home)</option>
              <option value="sidebar">Sidebar</option>
              <option value="inline">Inline</option>
            </select>
            <label className="flex items-center gap-2 font-sans-ui text-sm"><input type="checkbox" checked={form.active} onChange={e => setForm({...form, active: e.target.checked})} /> Ativo</label>
            <button type="submit" className="bg-black text-white px-4 py-2 w-full font-sans-ui text-sm uppercase tracking-widest font-semibold" data-testid="banner-submit"><Plus size={14} className="inline mr-2"/>Cadastrar</button>
          </form>
          <div className="md:col-span-2 space-y-3">
            {items.map(b => (
              <div key={b.id} className="border border-zinc-300 bg-white p-3 flex gap-4 items-center">
                <img src={b.image} alt="" className="w-32 h-20 object-cover" />
                <div className="flex-1">
                  <p className="font-serif-display font-semibold">{b.title}</p>
                  <p className="font-sans-ui text-xs text-zinc-500">{b.position} · {b.active ? "Ativo" : "Inativo"}</p>
                </div>
                <button onClick={() => remove(b.id)} className="p-1.5 border border-zinc-300 text-red-700"><Trash2 size={14}/></button>
              </div>
            ))}
            {items.length === 0 && <p className="text-center text-zinc-500 font-sans-ui p-6 border border-zinc-300 bg-white">Nenhum banner.</p>}
          </div>
        </div>
      </div>
    </AdminLayout>
  );
}
